import { render } from "./Help-center-category.vue?vue&type=template&id=043437de&scoped=true"
import script from "./Help-center-category.vue?vue&type=script&lang=js"
export * from "./Help-center-category.vue?vue&type=script&lang=js"

import "./Help-center-category.vue?vue&type=style&index=0&id=043437de&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-043437de"]])

export default __exports__